/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import { ReadAloudIcon } from "components/readAloud/ReadAloudIcon";
import startReadAloudIcon from "dc-icons/viewer2021/SDC_ReadAloudListen_18_N.svg";
import * as stores from "stores";
import {
  wrappedReadAloudRatePickerContainer as ReadAloudRatePicker,
  wrappedReadAloudPrevContainer as ReadAloudPrev,
  wrappedReadAloudPlayPauseContainer as ReadAloudPlayPause,
  wrappedReadAloudNextContainer as ReadAloudNext,
  wrappedReadAloudVoicePickerContainer as ReadAloudVoicePicker,
  wrappedReadAloudStopButton as ReadAloudStop,
  wrappedReadAloudFileName as FileName
} from "../reusableComponents";
import { getFocusElementCallback } from "selectors/accessibilitySelectors";

export const readAloudIcon = {
  id: "readAloudIcon",
  Component: <ReadAloudIcon />
};

export const readAloudFileName = {
  id: "readAloudFileName",
  Component: <FileName />
};

export const getReadAloudStartAction = ({ intl }) => ({
  id: "readAloudStart",
  tooltip: intl.formatMessage({ id: "tooltip.readAloudStart" }),
  label: intl.formatMessage({ id: "arialabel.readAloudStart" }),
  onClick: () => stores.readAloudStore.startHandler(),
  Icon: startReadAloudIcon,
  refCallback: getFocusElementCallback(stores, "readAloudStart")
});

export const readAloudStopAction = {
  id: "readAloudStop",
  Component: <ReadAloudStop />
};

export const readAloudRatePicker = {
  id: "readAloudRatePicker",
  Component: <ReadAloudRatePicker />
};

export const readAloudPrev = {
  id: "readAloudPrev",
  Component: <ReadAloudPrev />
};

export const readAloudPlayPause = {
  id: "readAloudPlayPause",
  Component: <ReadAloudPlayPause />
};

export const readAloudNext = {
  id: "readAloudNext",
  Component: <ReadAloudNext />
};

export const readAloudVoicePicker = {
  id: "readAloudVoicePicker",
  Component: <ReadAloudVoicePicker />
};
